import { gql, useQuery } from "@apollo/client";
import { datadogLogs } from "@datadog/browser-logs";
import useCheckPC from "@repo/hooks/utils/useCheckPC";
import type { IMenuQuery } from "@repo/shopify/src/queries/others-gql";
import { menuQuery } from "@repo/shopify/src/queries/others-gql";
import classNames from "classnames";
import React from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";

import Icon from "@components/atoms/Icon";
import Logo from "@components/atoms/Logo";

import Button from "@atoms/Button";

import LeftMenu from "@organisms/Header/LeftMenu";
import RightMenu from "@organisms/Header/RightMenu";
import StoreNav from "@organisms/Header/StoreNav";

import useLayout from "@hooks/reducerHooks/useLayout";
import useCheckLocation from "@hooks/useCheckLocation";

import { IconName } from "@const/enum";
import { URLS } from "@const/urls";

function Header({ isSaleShutDown }: { isSaleShutDown: boolean }) {
  const navigate = useNavigate();

  /** header에서 메뉴 항목이 열렸을때 스크롤 방지하는 작업 필요 **/
  const { isHeaderOpen } = useLayout();
  const { pathname } = useLocation();
  const { isPC } = useCheckPC();
  const { isEventPage } = useCheckLocation();

  const logoOnly =
    matchPath(URLS.CHECKOUT, pathname) ||
    // matchPath(URLS.DRAW_CHECKOUT, pathname) ||
    matchPath(URLS.DRAW_ENTRY_DETAIL, pathname);

  // 미리 쿼리를 위해 헤더에서 조회
  const { data } = useQuery<IMenuQuery>(gql(menuQuery.query), {
    // 평시에는 'store' | 프로모션할 때는 'promotion-store'
    variables: { handle: "archive-sale" },
    onError: (error) => {
      datadogLogs.logger.error("[SHOPIFY][Menu] Failed to query", error);
      throw new Error(`[SHOPIFY][Menu] Failed to query : ${JSON.stringify(error)}`);
    },
  });

  return (
    <header
      className={classNames("pc:h-auto top-0 right-0 z-30 w-full", isPC ? "sticky" : isHeaderOpen ? "fixed" : "sticky")}
    >
      <div
        className={classNames(
          "pc:px-5 grid grid-cols-3 items-center px-4 py-2.5",
          isHeaderOpen ? "bg-secondary text-quaternary" : "bg-primary",
          !isHeaderOpen && isEventPage && "text-quaternary bg-transparent",
        )}
      >
        {logoOnly ? (
          <>
            <Button
              className="flex w-fit justify-start bg-transparent uppercase active:scale-100!"
              onClick={() => {
                navigate(-1);
              }}
              variant="icon"
            >
              <Icon
                alt="leftArrow_700"
                className="text-black"
                height="24px"
                name={IconName.LeftArrow_700}
                width="24px"
              />
              <span className="h-4 text-black">Back</span>
            </Button>
            <Logo />
          </>
        ) : (
          <>
            <LeftMenu isSaleShutDown={isSaleShutDown} />
            <Logo goToUrl={isSaleShutDown ? URLS.ACCOUNT_ORDER_HISTORY : URLS.HOME} />
            <RightMenu isSaleShutDown={isSaleShutDown} />
          </>
        )}
      </div>
      {isHeaderOpen ? <StoreNav storeNav={data} /> : null}
    </header>
  );
}

export default Header;
